module.exports = __webpack_public_path__ + "8f617b8ab72dab3e0c106b0ea3b35fda.png";